const throttler = (handler, time = 66) => {
  let timeout;

  // ignore resize events as long as an handler execution is in the queue
  if (!timeout) {
    timeout = setTimeout(function() {
      timeout = null;
      handler();
    }, time);
  }
};

export default throttler;
